export enum ScatterPlotChartSize {
    basic_650 = 'basic_650',
    basic_850 = 'basic_850',
    basic_1200 = 'basic_1200',
    basic_2000 = 'basic_2000',
}

// ScatterPlotParams constants
export enum ScatterPlotChartType {
    interactive = 'interactive',
    presentation = 'presentation',
}
export enum ScatterPlotPlotType {
    pointInTime = 'point_in_time',
    timeseries = 'timeseries',
}
export enum ScatterPlotSeriesType {
    security = 'security',
    securityList = 'security_list',
    efficientFrontier = 'efficient_frontier',
}

// From '#point sizes/shapes' in ycharts/constants.py
export enum ScatterPlotDataShapeSize {
    small = 'small',
    medium = 'medium',
    large = 'large',
}
export enum ScatterPlotDataShape {
    circle = 'circle',
    cross = 'cross',
    diamond = 'diamond',
    triangle = 'triangle',
}

export enum ScatterPlotLabelPlacement {
    default = '',
    top_left = 'label_placement_top_left',
    left = 'label_placement_left',
    bottom_left = 'label_placement_bottom_left',
    top_right = 'label_placement_top_right',
    right = 'label_placement_right',
    bottom_right = 'label_placement_bottom_right',
}

// This is used on the front end only, the backend only cares about startDate and endDate
export enum ScatterPlotDateRangeType {
    date = 'date',
    year = 'year',
}

export enum ScatterPlotChartOptionValue {
    // Interactive
    displayAllTickers = 'displayAllTickers',
    displayAllXYData = 'displayAllXYData',
    displayAllCurrencyCodes = 'displayAllCurrencyCodes',
    displayAllDates = 'displayAllDates',
    displayAllNames = 'displayAllNames',
    displayBestFitLine = 'displayBestFitLine',
    displayLegend = 'displayLegend',
    displayCurrencyCodeInLegend = 'displayCurrencyCodeInLegend',
    displayXYDataInLegend = 'displayXYDataInLegend',
    displayColorRange = 'displayColorRange',
    nameInLegend = 'nameInLegend',
    useCustomColors = 'useCustomColors',
    // Annotations
    plotLines = 'plotLines',
    // Presentation
    displayLegendOnChart = 'displayLegendOnChart',
    performanceDisclosure = 'performanceDisclosure',
}

export enum ScatterPlotPresentationOptionValue {
    title = 'title',
    note = 'note',
    size = 'size',
    legendOrientation = 'legendOrientation',
}

export enum ScatterPlotPlotOptionValue {
    color = 'color',
    shape = 'shape',
    displayXYData = 'display_x_y_data',
    displayCurrencyCode = 'display_currency_code',
    displayDates = 'display_dates',
    includeInLegend = 'include_in_legend',
    displayName = 'display_name',
    displayTicker = 'display_ticker',
    labelPlacement = 'label_placement',
    size = 'size',
    name = 'name',
    includeThroughLine = 'include_through_line',
    seriesLabelLocation = 'series_label_location',
    canSelectPoint = 'can_select_point',
    series_class = 'series_class',
    lineColor = 'line_color',
    lineWidth = 'line_width',
    selectedColor = 'selected_color',
    parentSecurityListName = 'parent_security_list_name',
    performanceDisclosure = 'performance_disclosure',
}

export enum ScatterPlotStatus {
    ok = 'ok',
    error = 'error',
    loading = 'loading',
    noData = 'noData',
    allSeriesExceedDataLimit = 'allSeriesExceedDataLimit',
    getStarted = 'getStarted',
}

export enum ScatterPlotAxisType {
    x = 'x',
    y = 'y',
}

export enum ScatterPlotPresentationValidModes {
    imageCode = 'image_code',
    imageCodeTemplate = 'image_code_template',
    imageContents = 'image_contents',
    imageDownload = 'image_download',
    imageAttachment = 'image_attachment',
    imageUrl = 'image_url',
}

export enum ScatterPlotLookbackType {
    oneYear = '1 Year',
    threeYears = '3 Years',
    fiveYears = '5 Years',
    tenYears = '10 Years',
    custom = 'Custom',
}

export enum ScatterPlotLookbackOptionXValues {
    oneYear = 'monthly_standard_deviation_annualized_1y',
    threeYears = 'monthly_standard_deviation_annualized_3y',
    fiveYears = 'monthly_standard_deviation_annualized_5y',
    tenYears = 'monthly_standard_deviation_annualized_10y',
}

export enum ScatterPlotLookbackOptionYValues {
    oneYear = 'annualized_one_year_total_return',
    threeYears = 'annualized_three_year_total_return',
    fiveYears = 'annualized_five_year_total_return',
    tenYears = 'annualized_ten_year_total_return',
}
